import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { uniqBy } from "lodash";
import { useMount } from "react-use";
import { useSelector } from "store/useSelector";
import { useGetPageFromPath } from "utils/customHooks/genericHooks";

const groupTilesFilterStateAtom = atomWithStorage<{
  searchText: string | null;
  searchTextDisplay: string;
  selectedGroupNames: string[];
}>("atom:groupTilesFilterState", {
  searchText: null,
  searchTextDisplay: "",
  selectedGroupNames: [],
});
export function useGroupTilesFilterState() {
  return useAtom(groupTilesFilterStateAtom);
}

/**
 * Hook to get all unique processes from selected groups on the All Work Schedules page.
 *
 * @returns {Process[]} Array of unique processes.
 */
export function useAllWorkSchedulesPageProcesses() {
  const { isAllWorkSchedulesPage } = useGetPageFromPath();
  const [{ selectedGroupNames }] = useGroupTilesFilterState();
  const allGroups = useSelector(state => state.legacy.allGroups);

  if (!isAllWorkSchedulesPage) {
    return [];
  }
  const selectedGroups = allGroups.filter(
    group =>
      selectedGroupNames.includes(group.summaryGroup) ||
      selectedGroupNames.includes(group.longName) ||
      selectedGroupNames.includes(group.shortName)
  );
  const processesInSelectedGroups = selectedGroups.flatMap(
    group => group.processes
  );

  return uniqBy(processesInSelectedGroups, process => process.id);
}

/** on mount, if url query contains "groups=", ensure groupTilesFilterState matches url state */
export function useSetGroupTilesFilterStateFromUrlOnMount() {
  const { isAllWorkSchedulesPage } = useGetPageFromPath();
  const [, setGroupTilesFilterState] = useGroupTilesFilterState();
  useMount(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const groups = searchParams.get("groups");
    if (isAllWorkSchedulesPage && groups) {
      setGroupTilesFilterState(prev => ({
        ...prev,
        selectedGroupNames: groups.split(","),
      }));
    }
  });
}
